/** The host-only cookie is shared across tabs. Rotate/revoke under one lock. */
export async function withCookieSessionLock<T>(action: () => Promise<T>): Promise<T> {
  if (navigator.locks) return await navigator.locks.request('oprus-crm-refresh', action);
  return action();
}
